import { render, staticRenderFns } from "./margin-payment.html?vue&type=template&id=16b1b71e&scoped=true&external"
import script from "./margin-payment.js?vue&type=script&lang=js&external"
export * from "./margin-payment.js?vue&type=script&lang=js&external"
import style0 from "./margin-payment.scss?vue&type=style&index=0&id=16b1b71e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b1b71e",
  null
  
)

export default component.exports